import React from "react";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";
import DeliveryIcon from "../assets/svg/DeliveryTruck.svg?react";
import { StockIndicator } from "../features/stock";
import useFormatter from "../hooks/useFormatter";
import { useItemEdsDateFormatted } from "@coworker/apprestructured/src/shared/hooks/item/useItemEdsDateFormatted";
import { useItemExpectedDelivery } from "@coworker/apprestructured/src/shared/hooks/item/useItemExpectedDelivery";

const Span = styled("span")`
  display: inline-block;
  ${(props) => (props.small ? "" : "font-weight: bold;")};

  span {
    color: var(--bti-red);
  }
`;
const SpanMargin = styled(Span)`
  margin-left: 8px;
`;
const ContainerPill = styled("div")`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const Pill = styled("div")`
  border: ${(props) => (props.noBorder ? "none" : "1px solid grey")};
  border-radius: ${(props) => (props.noBorder ? "0px" : "25px")};
  font-size: 12px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 10px;
  ${(props) => (props.small ? "" : "height: 40px;")};
  padding: ${(props) => (props.small ? "0" : "0px 16px")};
`;

export function StockInfoPills({
  type,
  short_id,
  countryId,
  stockInfo,
  noBorder,
  small = false,
}) {
  const { t } = useTranslation();
  const { isLoading, edsDate } = useItemEdsDateFormatted(short_id);
  const { formatNumber, formatDateShort } = useFormatter();

  const { data: itemDeliveryData, isLoading: isLoadingDeliveryData } =
    useItemExpectedDelivery(short_id);

  const { available, elevated, loading, color } = stockInfo ?? {};

  function returnFormattedStockData(quantity) {
    if (!quantity && quantity !== 0) return "";
    return `${formatNumber(quantity)}`;
  }

  const formattedElevated = returnFormattedStockData(elevated); // This is "" initially, then becomes "0" or some other string of a number.

  const hasDeliveryInfo =
    !!itemDeliveryData &&
    (itemDeliveryData.deliveryDate || itemDeliveryData.deliveryQuantity > 0);

  return (
    <ContainerPill data-testid="stockInfoPills" small={small}>
      {!loading && (
        <Pill noBorder={noBorder} small={small}>
          <StockIndicator color={color} marginRight={8} size={8} />
          <Span small={small}>
            {returnFormattedStockData(available)}
            {!!formattedElevated && <> ({formattedElevated})</>}
          </Span>
        </Pill>
      )}
      {!isLoadingDeliveryData && hasDeliveryInfo && (
        <Pill noBorder={noBorder} small={small}>
          <DeliveryIcon />
          <SpanMargin>
            {itemDeliveryData.deliveryDate &&
              formatDateShort(itemDeliveryData.deliveryDate)}
            {itemDeliveryData.deliveryQuantity > 0 && (
              <>
                {itemDeliveryData.deliveryDate && ", "}
                {returnFormattedStockData(itemDeliveryData.deliveryQuantity)}
                {t("pcsString")}
              </>
            )}
          </SpanMargin>
        </Pill>
      )}
      {!isLoading && !!edsDate && (
        <Pill noBorder={noBorder} small={small}>
          <Span>
            <span>EDS: {edsDate}</span>
          </Span>
        </Pill>
      )}
    </ContainerPill>
  );
}
